import {takeLatest, put} from 'redux-saga/effects';

import {
  requestClassrooms,
  unloadClassrooms,
} from 'static/three-oh/src/modules/actions/classroomActions';

import {
  REQUEST_INITIAL_BINDER_DATA,
  UNLOAD_BINDER_DATA,
} from '../constants/binderActionTypes';


function * watchRequestInitialBinderData() {
  yield takeLatest(REQUEST_INITIAL_BINDER_DATA, function * (action) {
    const {currentUserId} = action;
    yield put(requestClassrooms(currentUserId));
  });
}

function * watchUnloadBinderData() {
  yield takeLatest(UNLOAD_BINDER_DATA, function * () {
    yield put(unloadClassrooms());
  });
}

export {watchRequestInitialBinderData, watchUnloadBinderData};
